export default __webpack_public_path__ + "static/media/iGnite-full.fd8375d3.jpg";